<template>
  <div class="footer-wrap">
    <div class="container">
      <el-row>
        <el-col :span="6" :xs="24">
          <div class="footer-logo-wrap">
            <div class="footer-logo">
              <img
                :src="
                  aboutContactData !== undefined
                    ? aboutContactData.footerlogo
                    : ''
                "
                alt=""
              />
            </div>
          </div>
        </el-col>
        <el-col :span="14" :xs="24">
          <div class="contact-body" v-html="contactText"></div> 
          <!-- <div v-if="currentLanguage == 'zh'">
            <span style="font-size:16px;">Copyright&copy; 2018 - 2020 深圳市鑫思诚科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备20046924号</a>&nbsp; Fax:0755-83266856 邮箱：cara@emotoecu.com  公司微信<span style="font-size:16px;white-space:normal;">公众</span>号：shzmst</span>
          </div>
          <div v-else="currentLanguage == 'en'">
            <div>Copyright&copy; 2018 - 2020 SHENZHEN XINSICHENG TECHNOLOGY CO.,LTD&nbsp; <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备20046924号</a> </div>
            <div>Tel:0086 18270886242&nbsp; Email: cara@emotoecu.com</div>
          </div> -->
        </el-col>
        <el-col :span="4" :xs="24">
          <div class="footer-qrcode-wrap">
            <div class="footer-qrcode">
              <img src="~@a/img/qrcode.png" alt="" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import API from "@/api";
import LStore from "store";

export default {
  data() {
    return {
      aboutContactData: undefined,
      currentLanguage: "en"
    };
  },
  computed: {
    ...mapState(["language"]),
    contactText() {
      let text =
        this.aboutContactData !== undefined
          ? this.aboutContactData.contact_content
          : "";
      text = text.replace(/\r\n/g, "<br/>");
      return text;
    }
  },
  created() {
    this.currentLanguage = LStore.get("language");
    this.aboutContact();
  },
  methods: {
    ...mapMutations(["ABOUT_CONTACT"]),
    aboutContact(params) {
      API.aboutContact(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "aboutContactData", res.data);
          // if(this.currentLanguage == "zh"){
          //   document.title = "深圳市鑫思诚科技有限公司"
          // }else{
          //   document.title = "Shenzhen Xinsicheng Technology Co., Ltd."
          // }
          document.title = res.data.title;
          this.ABOUT_CONTACT(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.footer-wrap {
  // position: fixed;
  // left: 0;
  // right: 0;
  // bottom: 0;
  padding: 15px;
  background: var(--color-grey-black);
  color: var(--color-grey-white);
  font-size: 12px;
  line-height: initial;
  z-index: 99999;

  p {
    padding: 5px;
  }

  .footer-logo-wrap {
    display: flex;
    height: 30px;
    align-items: center;
  }

  .footer-logo {
    width: 180px;
  }

  .footer-qrcode-wrap {
    display: flex;
    height: 30px;
    align-items: center;
    justify-content: flex-end;
  }

  .footer-qrcode {
    width: 30px;
    margin-right: 20px;
  }
}

@media only screen and (max-width: 767px) {
  .footer-wrap {
    text-align: center;
    .footer-logo-wrap,
    .footer-qrcode-wrap {
      justify-content: center !important;
    }

    .footer-qrcode {
      margin: 30px 0 0;
      padding-bottom: 20px;
    }
  }
}
</style>
